"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalInfoFieldLastName = PersonalInfoFieldLastName;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const account_1 = require("@src/types/account");
function PersonalInfoFieldLastName() {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: account_1.EPersonalInfoField.lastName, label: intl.formatMessage({ id: 'admin.personal_info_edit.last_name' }), rules: [
            {
                required: true,
                message: intl.formatMessage({
                    id: 'admin.personal_info_edit_validation.please_fill_last_name',
                }),
            },
            {
                // eslint-disable-next-line
                pattern: /^[^0-9_~`!@#$%^&*(),.;<>?{}\[\]\\\/]+$/g,
                message: intl.formatMessage({
                    id: 'admin.personal_info_edit_validation.forbidden_characters',
                }),
            },
        ], children: (0, jsx_runtime_1.jsx)(elements_1.Input, { maxLength: 255 }) }));
}
